import { render } from "./dxgladd.vue?vue&type=template&id=32764582&scoped=true"
import script from "./dxgladd.vue?vue&type=script&lang=js"
export * from "./dxgladd.vue?vue&type=script&lang=js"

import "./dxgladd.vue?vue&type=style&index=0&id=32764582&lang=scss&scoped=true"
import "./dxgladd.vue?vue&type=style&index=1&id=32764582&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32764582"]])

export default __exports__